import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import {
    FormControlLabel,
    Checkbox,
    FormGroup,
    List,
    ListItem,
    Typography,
    Autocomplete,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import axios from "../../../../lib/axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import axiosInstance from "../../../../lib/axios";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";
import { useReactToPrint } from "react-to-print";
import { getFormMode } from "../../../../lib/helpers";
import { z } from "zod";


const FORM_MODE = getFormMode();

const categoryFormSchema = z.object({
    HsnChp_Key: z.string().min(1, "Chapter is required"),
    HsnSubChp_Key: z.string().min(1, "Sub-Chapter is required"),
    Hsn_Code: z.string().min(1, "HSN Code is required"),
    HsnCode_Desc: z.string().optional(),
    Remk: z.string().optional(),
    Status: z.enum(["1", "0"]).optional(),
});
const FORM_INIT_STATE = {
    HsnCode_Key: "",
    HsnChp_Key: "",
    HsnSubChp_Key: "",
    Hsn_Code: "",
    HsnCode_Desc: "",
    Remk: "",
    Status: FORM_MODE.add ? "1" : "0",
};

const columns = [
    { id: "RowNum", label: "Sr.No.", minWidth: 5 },
    { id: "HsnCode_Key", label: " HsnCodeKey", minWidth: 100 },
    { id: "Hsn_Code", label: " HsnCodeName", minWidth: 100 },
    { id: "HsnChap_Name", label: "HsnChapName", minWidth: 100 },
    { id: "HsnSubChap_Name", label: "HsnSubChapName", minWidth: 100 },
    { id: "Remk", label: "Remark", minWidth: 100 },
    { id: "Status", label: "Status", minWidth: 50 },
];

const HsnCdMst = () => {
    const [formData, setFormData] = useState(FORM_INIT_STATE);
    const navigate = useNavigate();
    const [UserId, setUserId] = useState(sessionStorage.getItem("UserId"));
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [location, setLocation] = useState(useLocation());
    const [Status, setStatus] = useState("1");
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);

    const [currentHsnCode_Key, setCurrentHsnCode_Key] = useState(() => {
        if (location.state && location.state?.HsnCode_Key) {
            console.log("hsncodekeydummy1", location.state.HsnCode_Key)
            return location.state && location.state?.HsnCode_Key;
        }
        return undefined;
    });
    const [mode, setMode] = useState(() =>
        currentHsnCode_Key ? FORM_MODE.read : FORM_MODE.add
    );

    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState({
        isOpen: false,
        payload: null,
    });

    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });

    const HsnChp_KeyRef = useRef(null);
    const HsnSubChp_KeyRef = useRef(null);
    const Hsn_CodeRef = useRef(null);
    const remkRef = useRef(null);
    const HsnCode_KeyRef = useRef(null);
    const [chapterOptions, setChapterOptions] = useState([]);
    const [subChapterOptions, setSubChapterOptions] = useState([]);


    const loadChapters = async () => {
        try {
            const res = await axiosInstance.post("/HsnCode/getGstChapdrp", {
                HsnChp_Key: "",
                Flag: "",
            });

            if (res.data.Status === 0 && Array.isArray(res.data.Data) && res.data.Data.length > 0) {
                const options = res.data.Data.map((item) => ({
                    label: `${item.HsnChap_Name || ""}`.trim(),
                    value: item.HsnChp_Key,
                }));

                setChapterOptions(options);

                // Auto-select first chapter
                const firstChapter = options[0];
                setFormData((prev) => ({
                    ...prev,
                    HsnChp_Key: firstChapter.value,
                    HsnSubChp_Key: "", // Reset sub-chapter
                }));
            }
        } catch (err) {
            toast.error("Failed to load Chapters");
            console.error(err);
        }
    };

    const loadSubChapters = async (chapterKey) => {
        if (!chapterKey) {
            setSubChapterOptions([]);
            return;
        }

        try {
            const res = await axiosInstance.post("/HsnCode/getGstSubChapdrp", {
                HsnChp_Key: chapterKey,
                Flag: "",
            });

            if (res.data.Status === 0 && Array.isArray(res.data.Data) && res.data.Data.length > 0) {
                const options = res.data.Data.map((item) => ({
                    label: `${item.HsnSubChap_Name || ""}`.trim(),
                    value: item.HsnSubChp_Key,
                }));

                setSubChapterOptions(options);

                // Auto-select first sub-chapter
                const firstSubChapter = options[0];
                setFormData((prev) => ({
                    ...prev,
                    HsnSubChp_Key: firstSubChapter.value,
                }));
            } else {
                setSubChapterOptions([]);
                setFormData((prev) => ({ ...prev, HsnSubChp_Key: "" }));
            }
        } catch (err) {
            toast.error("Failed to load Sub-Chapters");
            console.error(err);
        }
    };

    useEffect(() => {
        loadChapters();
    }, []);

    useEffect(() => {
        loadSubChapters(formData.HsnChp_Key);
    }, [formData.HsnChp_Key]);

    useEffect(() => {
        const getRow = async () => {
            try {
                const res = await axiosInstance.post('HsnCode/GetHsnCodeDashBoard', {
                    start: 1,
                    PageSize: 1,
                    SearchText: "",
                });
                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                } else {
                    console.error('No data found in response');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    useEffect(() => {
        const state = location.state;

        if (state?.mode === "add" && state?.HsnCode_Key) {
            // Coming from Table "New" button with pre-generated key
            setCurrentHsnCode_Key(state.HsnCode_Key);
            setMode(FORM_MODE.add);
            setIsFormDisabled(false);
            setFormData({
                HsnCode_Key: state.HsnCode_Key,
                HsnChap_Name: "",
                HsnChap_Desc: "",
                Remk: "",
                Status: "1",
            });

            setStatus("1");

            // Focus the first field
            setTimeout(() => HsnCode_KeyRef.current?.focus(), 100);
        }
        else if (state?.HsnCode_Key && state?.mode === "view") {
            setCurrentHsnCode_Key(state.HsnCode_Key);
            fetchRetriveData(state.HsnCode_Key, "R");
            setMode(FORM_MODE.read);
        }
        else {
            // Default add mode (no key passed)
            setMode(FORM_MODE.add);
            setIsFormDisabled(false);
            setFormData(FORM_INIT_STATE);
        }
    }, [location.state]);

    const fetchRetriveData = async (id, flag = "") => {
        if (!id) return;
        try {
            const response = await axiosInstance.post(`HsnCode/RetriveHsnCode`, {
                HsnCode_Key: id,
                Flag: flag,
            });

            const { Status, Data } = response.data;

            if (Status === 0 && Data && Data.length > 0) {
                const row = Data[0];
                setFormData({
                    HsnCode_Key: row.HsnCode_Key,
                    HsnChp_Key: row.HsnChp_Key || "",
                    HsnSubChp_Key: row.HsnSubChp_Key || "",
                    Hsn_Code: row.Hsn_Code || "",
                    HsnCode_Desc: row.HsnCode_Desc || "",
                    Remk: row.Remk || "",
                    Status: row.Status?.toString() || "1",
                });
                setStatus(row.Status?.toString() || "1");
                setCurrentHsnCode_Key(row.HsnCode_Key);
                setIsFormDisabled(true);
                return row.HsnCode_Key;
            } else {
                toast.error("No data found for this record.");
            }
        } catch (error) {
            console.error("Error in RetriveHsnCode:", error);
        }
    };

    const fetchNextHsnCodeKey = async () => {
        try {
            const res = await axiosInstance.post('/HsnCode/GetSeriesLastNewKey', {
                ModuleName: "HSNCODE",
                TblName: "HSNCODE",
                ColName: "HSNCODE_KEY",
                Ncollen: 5,
                CPrefix: "GH",
                FLAG: ""
            });

            if (res.data.Status === 0 && res.data.Data?.[0]?.DocKey) {
                return res.data.Data[0].DocKey;
            }
            throw new Error("Invalid response");
        } catch (err) {
            console.error("Failed to generate HSN Code Key");
            return "GH001";
        }
    };
    const handlePrevious = async () => {
        if (!currentHsnCode_Key) return;

        // Extract number from "GH001", "GH002", "ABC123" → 1, 2, 123
        const currentNum = parseInt(currentHsnCode_Key.match(/\d+/)?.[0] || "0", 10);

        if (currentNum > 1) {
            await fetchRetriveData(currentHsnCode_Key, "P");
        }
        //  else {
        //     toast.info("You are at the first record", { autoClose: 500 });
        // }
    };

    const handleNext = async () => {
        if (currentHsnCode_Key) {
            await fetchRetriveData(currentHsnCode_Key, "N");
        }
    };

    const handleEdit = () => {
        setMode(FORM_MODE.edit);
        setIsFormDisabled(false);
    };

    const handleAdd = async () => {
        const nextKey = await fetchNextHsnCodeKey();

        setMode(FORM_MODE.add);
        setIsFormDisabled(false);
        setCurrentHsnCode_Key(nextKey);

        setFormData({
            HsnCode_Key: nextKey,     // ← Auto-generated
            HsnChp_Key: "",
            HsnSubChp_Key: "",
            Hsn_Code: "",
            HsnCode_Desc: "",
            Remk: "",
            Status: "1",
        });
        // Focus first editable field
        setTimeout(() => HsnChp_KeyRef.current?.focus(), 100);
    };

    const handleExit = () => {
        navigate("/hsn-code-table", { replace: true });
    };

    const handleDelete = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    // const handleConfirmDelete = async () => {
    //     setOpenConfirmDialog(false);
    //     try {
    //         const response = await axiosInstance.post(
    //             `/HsnCode/DeleteGstChap`,
    //             {
    //                 HsnCode_Key: currentHsnCode_Key,
    //             }
    //         );
    //         const {
    //             data: { Status, Message, Data },
    //         } = response;
    //         if (Status === 0) {
    //             toast.success(Message, { autoClose: 1000 });
    //             await fetchRetriveData(currentHsnCode_Key, "N");
    //         } else {
    //             if (Array.isArray(Data) && Data.length > 0) {
    //                 const msg = formatDeleteErrorMessage(Data);
    //                 toast.error(msg, { autoClose: 1000 });
    //             } else {
    //                 toast.error(Message, { autoClose: 1000 });
    //             }
    //         }

    //         await fetchRetriveData(currentHsnCode_Key, "N");
    //         setMode(FORM_MODE.read);
    //         setIsFormDisabled(true);
    //     } catch (error) {
    //         return error;
    //     }
    // };
    const handleConfirmDelete = async () => {
        setOpenConfirmDialog(false);

        if (!currentHsnCode_Key) {
            toast.error("No record selected to delete");
            return;
        }

        try {
            const response = await axiosInstance.post("/HsnCode/DeleteGstChap", {
                HsnCode_Key: currentHsnCode_Key,
            });

            const { Status, Message, Data } = response.data;

            if (Status === 0) {
                toast.success(Message || "Deleted successfully!", { autoClose: 1000 });

                // NOW get the next valid record properly
                const nextKey = await fetchRetriveData(currentHsnCode_Key, "N");

                if (nextKey) {
                    // Successfully loaded next record
                    setCurrentHsnCode_Key(nextKey);
                    setMode(FORM_MODE.read);
                    setIsFormDisabled(true);
                } else {
                    // No next record? Go to last, or switch to Add mode
                    toast.info("No more records. Switching to Add mode.");
                    handleAdd(); // This generates new key + clean form
                }
            } else {
                // Delete failed
                const msg = Array.isArray(Data) && Data.length > 0
                    ? formatDeleteErrorMessage(Data)
                    : Message || "Delete failed";
                toast.error(msg);
                // Do NOT navigate away or reload
            }
        } catch (error) {
            console.error("Delete error:", error);
            toast.error("Network error during delete");
        }
    };
    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
        setFormData((prevState) => ({
            ...prevState,
            Status: updatedStatus,
        }));
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            const refs = [HsnChp_KeyRef, HsnSubChp_KeyRef, Hsn_CodeRef, remkRef];
            const currentIdx = refs.findIndex(ref => ref.current === event.target);
            if (currentIdx > -1 && currentIdx < refs.length - 1) {
                refs[currentIdx + 1].current?.focus();
            }
        }
    };

    const handleSubmit = async () => {
        const result = categoryFormSchema.safeParse(formData);
        if (!result.success) {
            toast.error("Please fill required details.");
            return;
        }
        const { data } = result;

        const payload = {
            HsnCode_Key: formData.HsnCode_Key,
            HsnChp_Key: data.HsnChp_Key || "",
            HsnSubChp_Key: data.HsnSubChp_Key || "",
            Hsn_Code: data.Hsn_Code || "",
            HsnCode_Desc: data.HsnCode_Desc || "",
            Remk: data.Remk || "",
            Status: data.Status || "1",
            Created_By: mode === FORM_MODE.add ? parseInt(UserId || "1", 10) : undefined,
            Updated_By: mode === FORM_MODE.edit ? parseInt(UserId || "1", 10) : undefined,
        };

        // Only send key on update
        if (mode === FORM_MODE.edit && currentHsnCode_Key) {
            payload.HsnCode_Key = currentHsnCode_Key;
        }

        try {
            const response = mode === FORM_MODE.edit
                ? await axiosInstance.patch(`/HsnCode/UpdateHsnCode`, payload)
                : await axiosInstance.post(`/HsnCode/InsertHsnCode`, payload);

            const { Status, Message, Data } = response.data;

            if (Status === 0) {
                toast.success(Message || "Saved successfully!", { autoClose: 1000 });

                if (mode === FORM_MODE.add && Data?.HsnCode_Key) {
                    setCurrentHsnCode_Key(Data.HsnCode_Key);
                    await fetchRetriveData(Data.HsnCode_Key, "R");
                }

                setMode(FORM_MODE.read);
                setIsFormDisabled(true);
            } else {
                toast.error(Message || "Save failed");
            }
        } catch (error) {
            console.error("Submit error:", error);
        }
    };

    const handleCancel = async () => {
        if (mode === FORM_MODE.add) {
            try {
                await fetchRetriveData(1, "L");
                setMode(FORM_MODE.read);
                setIsFormDisabled(true);
            } catch (error) {
                console.error('Error occurred while cancelling. Please try again.');
            }
        } else if (mode === FORM_MODE.edit) {
            if (currentHsnCode_Key) {
                await fetchRetriveData(currentHsnCode_Key, "R");
            }
            setMode(FORM_MODE.read);
            setIsFormDisabled(true);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    return (
        <>
            <Box
                className="form-container"
                sx={{
                    width: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                    maxWidth: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                    overflowX: "hidden",
                    overflowY: { xs: "auto", sm: "hidden", md: "hidden" },
                }}
            >
                <ToastContainer />
                <Grid
                    container
                    spacing={2}
                    sx={{
                        width: { xs: "93%", sm: "80%", md: "80%" },
                        height: { xs: "460px", sm: "auto", md: "auto" },
                        margin: "auto",
                        marginTop: { xs: "60px", sm: 0, md: "auto" },
                        marginBottom: { xs: "110px", sm: 0, md: "auto" },
                        borderRadius: "8px",
                        padding: { xs: "0px 5px 5px 5px", sm: "0px 20px 20px 20px" },
                        backgroundColor: "#fff",
                    }}
                >
                    <Grid
                        item
                        xs={12}
                        className="form_title"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: "30px",
                            marginInline: { xs: "0px", sm: "2px", md: "20px" },
                            flexDirection: { xs: "column", sm: "row", md: "row" },
                            overflow: "hidden",
                        }}
                    >
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: { xs: "center", sm: "flex-start" },
                                marginBottom: { xs: "10px", sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{
                                    backgroundColor: "#635BFF",
                                    marginRight: { xs: "0px", sm: "10px" },
                                    display: "block",
                                }}
                                disabled={
                                    mode !== FORM_MODE.read ||
                                    !currentHsnCode_Key ||
                                    currentHsnCode_Key === 1
                                }
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{
                                    backgroundColor: "#635BFF",
                                    display: "block",
                                }}
                                disabled={mode !== FORM_MODE.read || !currentHsnCode_Key}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>
                        <Typography
                            variant="h5"
                            sx={{
                                margin: "auto",
                                textAlign: { xs: "center", sm: "center" },
                                fontSize: { xs: "22px", sm: "18px", md: "24px" },
                            }}
                        >
                            HSN Code Master
                        </Typography>
                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="HSN/SAC Code"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                // onDelete={handleDelete}   ← COMMENT OUT OR REMOVE THIS LINE
                                onDelete={() => { }}
                                onView={handlePrint}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={mode === FORM_MODE.read}
                                // ←←← THIS IS THE ONLY LINE YOU ADD IN THIS FILE
                                forceDisableDelete={true}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            mx: "auto",
                        }}
                    >
                        <Grid
                            container
                            spacing={1}
                            justifyContent="center"
                            sx={{ maxWidth: "800px", width: "100%" }}
                        >
                            <Grid item xs={12} md={10}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            id="HsnCode_Key"
                                            name="HsnCode_Key"
                                            label="Code"
                                            variant="filled"
                                            fullWidth
                                            disabled={true}
                                            className="custom-textfield"
                                            value={formData.HsnCode_Key}
                                            onChange={handleInputChange}
                                            // disabled={mode === FORM_MODE.read}
                                            inputRef={HsnCode_KeyRef}           // ← Add this
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4.5}>
                                        <Autocomplete
                                             disabled={mode !== FORM_MODE.add}  
                                            options={chapterOptions}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={chapterOptions.find((opt) => opt.value === formData.HsnChp_Key) || null}
                                            onChange={(event, newValue) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    HsnChp_Key: newValue ? newValue.value : "",
                                                    HsnSubChp_Key: "", // Reset sub-chapter
                                                }));
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    // label="Chapter"
                                                    label={
                                                        <>
                                                            Chapter <span style={{ color: "red" }}>*</span>
                                                        </>
                                                    }
                                                    variant="filled"
                                                    fullWidth
                                                    className="custom-textfield"
                                                    inputRef={HsnChp_KeyRef}
                                                    onKeyDown={handleKeyPress}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4.5}>
                                        <Autocomplete
                                            disabled={mode !== FORM_MODE.add}  
                                            options={subChapterOptions}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={subChapterOptions.find((opt) => opt.value === formData.HsnSubChp_Key) || null}
                                            onChange={(event, newValue) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    HsnSubChp_Key: newValue ? newValue.value : "",
                                                }));
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={
                                                        <>
                                                            Sub-Chapter <span style={{ color: "red" }}>*</span>
                                                        </>
                                                    }
                                                    variant="filled"
                                                    fullWidth
                                                    className="custom-textfield"
                                                    inputRef={HsnSubChp_KeyRef}
                                                    onKeyDown={handleKeyPress}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={10}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            fullWidth
                                            id="Hsn_Code"
                                            name="Hsn_Code"
                                            label={
                                                <>
                                                    HSN Code <span style={{ color: "red" }}>*</span>
                                                </>
                                            }
                                            value={formData.Hsn_Code}
                                            onChange={handleInputChange}
                                            variant="filled"
                                            disabled={mode === FORM_MODE.read}
                                            className="custom-textfield"
                                            inputRef={Hsn_CodeRef}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <TextField
                                            fullWidth
                                            label="Description"
                                            name="HsnCode_Desc"
                                            value={formData.HsnCode_Desc}
                                            onChange={handleInputChange}
                                            variant="filled"
                                            disabled={mode === FORM_MODE.read}
                                            className="custom-textfield"
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={10}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <TextField
                                            fullWidth
                                            label="Remark"
                                            name="Remk"
                                            value={formData.Remk}
                                            onChange={handleInputChange}
                                            variant="filled"
                                            disabled={mode === FORM_MODE.read}
                                            className="custom-textfield"
                                            inputRef={remkRef}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={10}>
                                <FormGroup sx={{ flexShrink: 0 }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={mode === FORM_MODE.read}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>

                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        className="form_button"
                        sx={{ marginBottom: "10px", marginInline: "20px" }}
                    >
                        {mode === FORM_MODE.read && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                                        "@media (max-width: 600px)": {
                                            padding: "0px 0px !important",
                                        },
                                    }}
                                    onClick={handleSubmit}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                                        "@media (max-width: 600px)": {
                                            padding: "0px 0px !important",
                                        },
                                    }}
                                    onClick={handleCancel}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === FORM_MODE.edit || mode === FORM_MODE.add) && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        "@media (max-width: 600px)": {
                                            padding: "0px 0px !important",
                                        },
                                    }}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        "@media (max-width: 600px)": {
                                            padding: "0px 0px !important",
                                        },
                                    }}
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>

                <div style={{ display: "none" }}>
                    {rows.length > 0 && (
                        <ReportTable
                            columns={columns}
                            rows={rows.map(row => ({
                                ...row,
                                Status: row.Status === "1" ? "Active" : row.Status === "0" ? "Inactive" : row.Status,
                            }))}
                            title="Hsn Code Master"
                            contentRef={contentRef}
                            customStyles={{ backgroundColor: "#f5f5f5" }}
                        />
                    )}
                </div>
                <Dialog
                    open={openConfirmDialog}
                    onClose={handleCloseConfirmDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete this record?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            sx={{
                                backgroundColor: "#635bff",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "#1565c0",
                                    color: "white",
                                },
                            }}
                            onClick={handleConfirmDelete}
                        >
                            Yes
                        </Button>
                        <Button
                            sx={{
                                backgroundColor: "#635bff",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "#1565c0",
                                    color: "white",
                                },
                            }}
                            onClick={handleCloseConfirmDialog}
                        >
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box> {/* Added closing Box tag */}
        </>
    );
};

export default HsnCdMst;